import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Card, Typography } from 'antd';
import { api } from '../../services/api'; // api instance'ını import et

const { Title } = Typography;

const AiSettingsPage: React.FC = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchSettings = async () => {
            setLoading(true);
            try {
                const response = await api.get('/api/v1/settings/ai');
                form.setFieldsValue(response.data);
            } catch (error) {
                message.error('AI ayarları yüklenirken bir hata oluştu.');
            }
            setLoading(false);
        };

        fetchSettings();
    }, [form]);

    const onFinish = async (values: any) => {
        setLoading(true);
        try {
            await api.post('/api/v1/settings/ai', values);
            message.success('AI ayarları başarıyla güncellendi.');
        } catch (error) {
            message.error('Ayarlar güncellenirken bir hata oluştu.');
        }
        setLoading(false);
    };

    return (
        <Card>
            <Title level={4}>Google AI Ayarları</Title>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                initialValues={{ model: 'gemini-1.5-flash' }}
            >
                <Form.Item
                    name="apiKey"
                    label="API Anahtarı"
                    help="Yeni bir anahtar girmeyecekseniz bu alanı boş bırakın."
                    rules={[{ required: false }]}
                >
                    <Input.Password placeholder="****..." />
                </Form.Item>
                <Form.Item
                    name="model"
                    label="Model Adı"
                    rules={[{ required: true, message: 'Lütfen bir model adı girin.' }]}
                >
                    <Input placeholder="örn: gemini-1.5-flash" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Kaydet
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default AiSettingsPage;
